export default "__VITE_ASSET__DxqXaO$w__"